var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.season24.season
    ? _c(
        "section",
        { staticClass: "top-section-calendar _js-scroll-animation-trigger" },
        [
          _c(
            "div",
            {
              staticClass: "bg",
              style: {
                backgroundImage: "url(" + _vm.season24.season.image + ")"
              }
            },
            [
              _c("div", { staticClass: "inner" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "body" }, [
                  _c("p", { staticClass: "period" }, [
                    _c("span", { staticClass: "-start" }, [
                      _vm._v(
                        _vm._s(_vm.dateSplit(_vm.season24.season.period)[0])
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "-end" }, [
                      _vm._v(
                        _vm._s(_vm.dateSplit(_vm.season24.season.period)[1])
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "title" }, [
                    _c("span", [_vm._v(_vm._s(_vm.season24.season.title))])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "en" }, [
                    _c("span", [_vm._v(_vm._s(_vm.season24.season.subtitle))])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "lead" }, [
                    _c("span", [_vm._v(_vm._s(_vm.season24.season.heading))])
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "cont",
                    domProps: {
                      innerHTML: _vm._s(_vm.h(_vm.season24.season.body))
                    }
                  })
                ])
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "logo" }, [
        _c("img", {
          attrs: {
            src: "/assets/img/top/top-section-calendar_logo.png",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "en" }, [_vm._v("LITERARY CALENDAR")]),
      _vm._v(" "),
      _c("h3", { staticClass: "hdg" }, [_vm._v("祇園の歳時記")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }